import { DESTINATIONS_STORAGE_KEY } from '@anm/constants/keys';

import isStudio from '../../../../../helpers/is/isStudio';
import { App } from '../../types';

const getDestinationStorageKey = (app?: App) => {
  const sufix: App = app || (isStudio() ? 'studio' : 'website');

  return `${DESTINATIONS_STORAGE_KEY}_${sufix}`;
};

export default getDestinationStorageKey;
